<template>
  <Card title="整合页设置" class="app-list">
    <div class="content">
      <Form
        autocomplete="off"
        class="form"
        hide-required-mark
        label-position="left"
        ref="form"
        :model="form"
        :rules="rule"
        :label-width="100"
      >
        <FormItem prop="title">
          <Input v-model="data.city_title">
            <span slot="prepend">页面标题</span>
          </Input>
        </FormItem>
        <FormItem prop="title">
          <Input v-model="data.city_footer">
            <span slot="prepend">页尾信息</span>
          </Input>
        </FormItem>

        <FormItem prop="title">
          <Collapse v-model="value3">
            <Panel name="1" hide-arrow>
              <span>页尾LOGO</span>
              <span style="color:red;margin-left:10px">(300px * 300px)</span>
              <div slot="content">
                <div class="demo-upload-list">
                  <template v-if="uploadList.status === 'finished'">
                    <img :src="uploadList.pic_url" />
                  </template>
                  <template v-else>
                    <Progress
                      v-if="uploadList.showProgress"
                      :percent="uploadList.percentage"
                      hide-info
                    ></Progress>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  multiple
                  type="drag"
                  action="/proxyapi/api/Upimg"
                  style="display: inline-block;width:58px;"
                >
                  <div style="width: 58px;height:58px;line-height: 58px;">
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>
              </div>
            </Panel>
          </Collapse>
        </FormItem>
        <FormItem prop="title">
          <Collapse v-model="value2">
            <Panel name="1" hide-arrow>
              轮播图设置
              <span style="color:red;margin-left:10px">(640px * 360px)</span>
              <div slot="content">
                <ul>
                  <li
                    class="img-content"
                    v-for="(item,index) in city_carousel_list"
                    :key="item.img"
                  >
                    <img :src="item.img" style="width:144px;height:81px;" />
                    <Button type="error" @click="city_carousel_list.splice(index,1)">删除</Button>
                  </li>
                </ul>
                <Button type="dashed" @click="dashed">添 加</Button>
                <Modal v-model="modal1" title="轮播图" @on-ok="ok" @on-cancel="cancel">
                  <Input v-model="value12">
                    <Select v-model="select1" slot="prepend" style="width: 80px">
                      <Option value="http://">http://</Option>
                      <Option value="https://">https://</Option>
                    </Select>
                  </Input>
                  <div class="upload">
                    <Upload
                      :show-upload-list="false"
                      type="drag"
                      action="/proxyapi/api/Upimg"
                      :on-success="handleSuccess2"
                      v-if="!imgUrl"
                    >
                      <div style="padding: 78px 0">
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>上传图片</p>
                      </div>
                    </Upload>
                    <img v-else class="img" :src="imgUrl" />
                  </div>
                </Modal>
              </div>
            </Panel>
          </Collapse>
        </FormItem>
        <!-- <FormItem label="页面标题" prop="title">
          <Input v-if="isEdit" v-model="form.title" clearable />
          <span v-else>{{ data.title }}</span>
        </FormItem>
        <FormItem label="轮播图" prop="bank_bankname">
          <Input v-if="isEdit" v-model="form.bank_bankname" clearable />
          <span v-else>{{ data.bank_bankname }}</span>
        </FormItem>
        <FormItem label="页尾信息" prop="bank_branchname">
          <Input v-if="isEdit" autocomplete="off" v-model="form.bank_branchname" clearable />
          <span v-else>{{ data.bank_branchname }}</span>
        </FormItem>
        <FormItem label="地理位置">
          <span>{{ data.bank_address }}</span>
        </FormItem>-->
        <FormItem v-if="!isEdit" style="text-align:center; padding:0 40px;">
          <Button type="primary" long @click="handleSubmit2">修改</Button>
        </FormItem>
        <FormItem v-else>
          <Button type="primary" @click="handleSubmit('form')">提交</Button>
          <Button @click="isEdit = !isEdit" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <!-- 页面 -->
      <div class="htmlBox" >
        <iframe
          v-if="hasBroadcast"
          :src="broadcast"
          marginwidth="0"
          marginheight="0"
          frameborder="0"
          width="320px"
          height="568px"
          class="iframeCss"
        ></iframe>
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
  </Card>
</template>

<script>
import {
  getAccountInfo,
  getLivestoreSetting,
  setLivestoreSetting
} from "@/service/api.js";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback("手机号格式不正确");
      } else {
        callback();
      }
    };
    return {
      spinShow: false,
      value2: "1",
      value3: "1",
      isEdit: false,
      // 同城趣直播页面地址
      hasBroadcast: false,
      broadcast: "https://v1.qddlive.cn/live/tongcheng/index.html?proxyid=1",
      data: {},
      form: {
        title: "", // 页面标题
        banner: [],
        foot: "", // 页尾信息-logo+描述
        position: "" // 地理位置-省市县三级
      },
      rule: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      city_carousel_list: [],
      modal1: false,
      uploadList: {},
      value12: "",
      select1: "http://",
      imgUrl: ""
    };
  },
  created() {
    this.spinShow = true;
    getLivestoreSetting().then(res => {
      let data = res.data;
      console.log(data);
      if (data.code == 0) {
        this.data = data.data.setting_data;
        this.uploadList.status = "finished";
        this.uploadList.pic_url = data.data.setting_data.city_logo;
        this.city_carousel_list = data.data.setting_data.city_carousel.list;
        this.spinShow = false;
      } else {
        this.$Message.error(data.msg);
      }
    });
  },
  mounted() {
    // 测试数据，记得删
    this.form = {
      title: "页面标题", // 页面标题
      banner: [],
      foot: "", // 页尾信息-logo+描述
      position: "广东省·广州市·天河区" // 地理位置-省市县三级
    };
    this.hasBroadcast = true;
    // this.getData();
  },
  methods: {
    dashed() {
      this.modal1 = true;
      this.value12 = "";
      this.imgUrl = "";
    },
    ok() {
      if (this.imgUrl) {
        // this.$Message.info("添加成功");
        this.value12
          ? (this.value12 = this.select1 + this.value12)
          : (this.value12 = "#");
        this.city_carousel_list.push({
          img: this.imgUrl,
          link: this.value12
        });
      } else {
        this.$Message.info("添加失败");
      }
    },
    cancel() {},
    handleSuccess(res, file) {
      console.log(res);
      console.log(file);
      this.uploadList = file;
      this.uploadList.pic_url = file.response.pic_url;
    },
    handleSuccess2(res, file) {
      this.imgUrl = file.response.pic_url;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },

    getData() {
      let params = {
        id: window.sessionStorage.getItem("proxyId")
      };
      getAccountInfo(params)
        .then(res => {
          let data = res.data;
          console.log(data);
          if (data.code == 0) {
            this.data = data.data;
            this.form = JSON.parse(JSON.stringify(data.data));
          } else {
            this.$Message.error(data.msg);
          }
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("获取失败!");
        });
    },
    handleSubmit2() {
      setLivestoreSetting({
        city_title: this.data.city_title,
        city_carousel: {
          list: this.city_carousel_list
        },
        city_logo: this.uploadList.pic_url,
        city_footer: this.data.city_footer
      })
        .then(res => {
          if (res.data.code == 0) {
            this.$Message.info("修改成功");
            this.hasBroadcast = false;
            this.hasBroadcast = true;
          } else {
            this.$Message.error("修改失败!");
          }
        })
        .catch(err => {
          this.$Message.error("修改失败!");
        });
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        console.log(valid);
        if (valid) {
          let params = {
            username: this.form.account,
            mobile: this.form.phone,
            email: this.form.email,
            password: this.form.password
          };

          console.log(params, "params");
          addStore(params)
            .then(res => {
              console.log(res);
              if (res.data.code == 0) {
                this.$Message.success("添加成功!");
                this.$refs[name].resetFields();
              } else {
                 this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg||"操作失败！",
            });

              }
            })
            .catch(err => {
              console.log(err);
              this.$Message.error("添加失败!");
            });
        } else {
          this.$Message.error({
            content: "表单内容不正确,请检查表单内容！",
            duration: 5
          });
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.img-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
}
.upload {
  margin-top: 20px;
  .img {
    width: 100%;
    height: 270px;
  }
}
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  .content {
    // padding: 50px;
    padding: 20px;
    background-color: #fff;
    border-radius: 3px;
    // box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    .form {
      width: 350px;
      display: inline-block;
    }

    .htmlBox {
      float: left;
      margin-bottom: 35px;
      border: 1px solid #ddd;
    }
  }
}
.bankImg {
  width: 300px;
  height: auto;
  // height: 300px;
}

.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
